import React from 'react';
import Locale from '../../domain/Locale';
import Color from '../../domain/Color';
import SponsorDomain from '../../domain/Sponsor';
import Layout from '../../components/Layout';
import Sponsor from '../../components/Sponsor';
import DefaultUi from '../../components/DefaultUi';
import HTMLComponent from '../../components/HTMLComponent';
import get_bundle from '../../domain/get_bundle';
import { privacyRcsUrl } from '../../util/privacyRcsUrl';
import template from 'lodash/string/template';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  sponsor: t.maybe(SponsorDomain),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  doAcceptCookies: t.Func,
  doAcceptRcsPrivacy: t.Func,
  partners: t.maybe(t.Obj)
})
export default class RcsPrivacy extends React.Component {

  getBgColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.bg_color;
  }

  getColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.color;
  }

  getDisclaimer() {
    const bundle = get_bundle(this.props.locale).rcs_privacy;
    const getLink = '<a href="' + privacyRcsUrl() + '" target="_blanck">' + bundle.privacy + '</a>';

    const msg = template(bundle.do_continue_hint)({
      privacy: getLink
    });

    return (
      <div className="disclaimer">
        <small>
          <HTMLComponent>
            {msg}
          </HTMLComponent>
        </small>
      </div>
    );
  }

  onSubmit = (evt) => {
    evt.preventDefault();
    this.props.doAcceptRcsPrivacy();
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor sponsor={this.props.sponsor} locale={this.props.locale} options={options} />);
  }

  render() {
    const { locale } = this.props;
    const bundle = get_bundle(locale).rcs_privacy;

    const boxStyle = {
      backgroundColor: this.props.themeBgColor,
      color: this.props.themeBgFontColor
    };

    const btnStyle = {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };

    return (
      <Layout sponsor={this.getSponsor()} partners={this.props.partners} bgColor={this.getBgColor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <DefaultUi id="rcs_privacy" title={bundle.title} themeBgColor={this.props.themeBgColor} themeBgFontColor={this.props.themeBgFontColor}>
          <div className="cols">
            <div className="large-60 small-hide">
              <div className="cell">
                <div className="cols">
                  <div className="large-100">
                    <div className="cell">
                      <h1>{bundle.free.title}</h1>
                      <p>{bundle.free.subtitle}</p>
                    </div>
                  </div>
                </div>
                <div className="cols">
                  <div className="large-100">
                    <div className="cell">
                      <h1>{bundle.unique.title}</h1>
                      <p>{bundle.unique.subtitle}</p>
                    </div>
                  </div>
                </div>
                <div className="cols">
                  <div className="large-100">
                    <div className="cell">
                      <h1>{bundle.safe.title}</h1>
                      <p>{bundle.safe.subtitle}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="large-40 large-pull-right small-100">
              <div id="form" className="box" style={boxStyle}>
                <form onSubmit={this.onSubmit}>
                  {this.getDisclaimer()}
                  <button id="do_accept_rcs_privacy" style={btnStyle} className="btn">{bundle.do_accept_rcs_privacy}</button>
                </form>
              </div>
            </div>
          </div>
        </DefaultUi>
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/RcsPrivacy.js
 **/